<template>
  <div class="payment-quotas" v-if="paymentsQuotas">
    <div class="payment-quotas-detail">
      <div class="payment-quotas-title">
        Paga en partes
        <small class="badge badge-pill badge-warning">Nuevo</small>
      </div>
      <span>Nueva forma de comprar en Joinnus.</span>
      <div class="payment-quotas-title">Selecciona la cantidad de cuotas que quieres pagar hoy</div>
      <div class="payment-quotas-option">
        <div class="payment-quotas-option-quotas" v-for="(item, i) in paymentsQuotas" :key="i">
          <label class="payment-quotas-option-quotas-item">
            <div class="">
              <input v-model="item.isChecked" type="checkbox" :id="`${item.order}° parte`"
                :disabled="item.transaction && item.transaction.isPayed === 1"
                @change="calculateTotalQuotes($event, item)" />
              <span style="margin-left: 5px">{{ `${item.order}° parte` }}</span>
            </div>
            <span>S/ {{ numberFormat(item.amount) }}</span>
            <span :class="[
              item.transaction && item.transaction.isPayed === 1
                ? 'payment-quotas-pay'
                : 'payment-quotas-prepay'
            ]" v-if="!isCreateFeePayment">
              {{
              item.transaction && item.transaction.isPayed === 1 ? 'Pagado' : 'Por pagar'
              }}</span>
          </label>
          <div :class="[item.isSelect === true ? '' : 'payment-quotas-option-ready']"></div>
        </div>
      </div>
      <div v-if="!verifyQuotasIsPayed">
        <small v-if="feePayments && existQuotasPayment">Tienes hasta el {{ getFormatDay(feePayments.expirationDate) }}
          de
          {{ getFormatMonth(feePayments.expirationDate) }} para pagar la totalidad de las
          cuotas.</small>
        <br />
        <div class="payment-quotas-option-quotas-total"
          v-if="existQuotasPayment && quotesTotal > 0 && isCreateFeePayment">
          <span>Pagarás la parte: <b>{{ parts }}</b></span>
          <span><b>S/ {{ numberFormat(sumQuotas) }}</b></span>

          <span>del total: <b>S/ {{ numberFormat(quotesTotal) }}</b></span>
        </div>
        <div class="payment-quotas-option-quotas-total"
          v-if="existQuotasPayment && quotesTotal > 0 && !isCreateFeePayment">
          <span>Pagarás la parte: <b>{{ parts }}</b></span>
          <span><b>S/ {{ numberFormat(sumQuotas) }}</b></span>
        </div>
        <span style="margin-top: 5px">Realiza el pago de tu entrada en partes, revisa nuestro Términos y condiciones del
          uso de
          este servicio.</span>
        <div class="text-center">
          <button type="button" class="btn btn btn-primary btn-round" style="margin: 20px 0px; padding: 6px 25px"
            @click="reservateQuotes()" :disabled="storeAddPayments">
            Ir a pagar
          </button>
        </div>
      </div>
      <div class="text-center mt-4" v-else>
        <a :href="`${baseUrlJn}/ticket-detail/${transactionId}/pos/${isFootball ? 'futbol' : 'ticket-pos-premium'
        }`" target="_blank" class="btn btn-action btn-lg">
          Imprimir
        </a>
      </div>
    </div>
  </div>
</template>

<script>
const { VUE_APP_BASE_URL_JN } = process.env;
export default {
  name: 'CardPaymentInQuotas',
  props: {
    feePayments: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    },
    meta:{
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    },
    transactionId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      sumQuotas: 0,
      parts: '',
      baseUrlJn: VUE_APP_BASE_URL_JN,
      isFootball: false,
    };
  },
  watch:{
    paymentsQuotas() {
      this.defaultValues();
    }
  },
  computed: {
    quotesTotal() {
      return this.paymentsQuotas.map((item) => item.amount).reduce((prev, curr) => prev + curr, 0);
    },
    paymentsQuotas() {
      return this.feePayments ? this.feePayments.feePayments : [];
    },
    existQuotasPayment(){
      if (!this.paymentsQuotas) {
        return false
      } 
      return this.paymentsQuotas.length > 0 ? true : false;
    },
    storeAddPayments(){
      return this.$store.state.cart.feePayments.length === 0 ? true : false;
    },
    isCreateFeePayment(){
      return this.$store.state.feePayments.isCreate;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    verifyQuotasIsPayed(){
      let isPayed = false;
      if (!this.isCreateFeePayment && this.paymentsQuotas.length > 0) {
        for (const elem of this.paymentsQuotas) {
          if (elem.transaction && elem.transaction.isPayed === 1) {
            isPayed = true;
          } else {
            isPayed = false;
          }
        }
      }
      return isPayed;
    },
  },
  methods: {
    setIsCreateFeePaymments() {
        const { name } = this.$route;
        if (name === 'Payment') {
          this.$store.dispatch('changeIsCreateFeePayment', false);
        }   
    },
    async reservateQuotes() {
      await this.$store.dispatch('changeStep',5);
      await this.$store.dispatch('changeReservePayments', true);
      if (!this.isCreateFeePayment) {
        this.$router.push({ name: 'Home' });
        this.$store.dispatch('returnPageFeePayment', true);
      } 
    },
    calculateTotalQuotes(event, item) {
      const quotas = [...this.paymentsQuotas];
      const limitQuotas = quotas.length;

      //Asign select
      if (item.isChecked === true && item.order < limitQuotas) {
        quotas[item.order].isSelect = true;
      } else {
        for (let index = item.order; index < quotas.length; index++) {
          quotas[index].isChecked = false; 
          quotas[index].isSelect = false; 
        }
      }

      const quotaTrue = quotas.filter((elem) => elem.isChecked === true && elem.state === 0);

      this.$emit('selectFeePayments', quotaTrue);
      const sumQuotas = quotaTrue.map((elem) => elem.amount).reduce((prev, curr) => prev + curr, 0);
      this.sumQuotas = sumQuotas;
      this.parts = this.calculateParts();
      
    },
    calculateParts() {
      let parts = [];
      const quotas = [...this.paymentsQuotas];
      quotas.forEach(elem => {
        if (elem.isChecked === true && elem.state===0) {
          parts.push(elem.order)
        }
      });
      return parts.toString();
    },
    defaultValues(){
      //Verificar isCreateFeePayment = true habilita la primera parte
      this.setIsCreateFeePaymments();
      if (this.paymentsQuotas && this.isCreateFeePayment) {
        const quotas = [...this.paymentsQuotas];
        quotas[0].isSelect = true;
      } else {
        this.verifyQuotasPaid()
      }
    },
    verifyQuotasPaid(){
      if (this.paymentsQuotas) {
        for (const element of this.paymentsQuotas) {
          if (element.state === 1) {
            element.isChecked = true;
          } 
        }
        const existeTransaction = this.paymentsQuotas.find(elem => elem.transaction && elem.state === 0);
        if (existeTransaction === undefined) {
          const transaction = this.paymentsQuotas.find(elem => !elem.transaction);
          if (transaction) {
            transaction.isSelect = true;
          }
        } else {
          if (existeTransaction.state === 0 && existeTransaction.transaction.isPayed === 0) {
            existeTransaction.isSelect = true;
          }
        }
      }
    }
  },
  created(){
    this.defaultValues();
  }
};
</script>
<style lang="scss" scoped>
.payment-quotas {
  &-title {
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 15px;
  }

  &-option {
    margin-top: 15px;

    &-quotas {
      border: 1px solid #bcc8d9;
      border-radius: 4px;
      padding: 5px 10px;
      margin-bottom: 5px;
      height: 55px;
      display: flex;
      align-items: center;
      position: relative;

      &:hover {
        border: 1px solid #1dc0c0;
      }

      &-total {
        border: 1px solid #42a692;
        background-color: #e4fbfb;
        border-radius: 4px;
        padding: 5px 15px;
        margin: 25px 0px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
      }

      &-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 5px;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }

  &-detail {
    border-radius: 8px;
    border: 1px solid #bcc8d9;
    padding: 15px 20px;
    margin-bottom: 30px;
  }

  .payment-quotas-detail:hover {
    border: 1px solid #1dc0c0;
  }

  .payment-quotas-option-ready {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 55px;
    background-color: rgba(188, 200, 217, 0.521);
    position: absolute;
    left: 0;
  }

  .payment-quotas-pay {
    height: 20px;
    background-color: #bcc8d9;
    color: #fff;
    width: 100px;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
  }

  .payment-quotas-prepay {
    height: 20px;
    background-color: #42a692;
    color: #fff;
    width: 100px;
    text-align: center;
    border-radius: 10px;
    font-size: 14px;
  }
}
</style>
